export default "__VITE_ASSET__GIHFulQD__"